import React, { useContext,useEffect } from "react";
import { useNavigate,useLocation } from "react-router-dom";
import styles from "./About.module.css";
import IndustryExpertise from "./IndustryExpertise";
import OfferSection from "./OfferSection";
import { AboutInfoSection } from "./AboutInfoSection";
import GlobalPartner from "./GlobalPartnerSection";
import { LetsPartnerSection } from "./LetsPartnerSection";
import PartnerInfo from "./PartnerInfo";
import ProcurementSupport from "./ProcurementSupport";
import { SelectedCardContext } from "../../Context/SelectedCardContext";

function About() {
  const { selectedCard } = useContext(SelectedCardContext);
  const navigate = useNavigate();
  const location = useLocation();
  const toggleDropdown = () => {
    navigate("/contact");
  };

  useEffect(() => {
    if (location.state && location.state.scrollTo) {
      const element = document.getElementById(location.state.scrollTo);
      if (element) {
          element.scrollIntoView({ behavior: "smooth" });
      }
      window.history.replaceState({}, document.title);
    }
  }, [location]);
  
  return (
    <section className={styles.aboutSectionContainer}>
      {!selectedCard && (
        <>
          <AboutInfoSection />
          <OfferSection />
          <IndustryExpertise />
          <GlobalPartner />
          <LetsPartnerSection />
          <PartnerInfo />
        </>
      )}

      {selectedCard && (
        <>
          <ProcurementSupport />
          <IndustryExpertise />
        </>
      )}
    </section>
  );
}

export default About;
